/**
 * Carousel
 * @external tns
 */

$('.slider').each(function (i, el) {
    const css               = 'slider';
    const $el               = $(el);
    const container         = $el.find(`.${css}__carousel`)[0];
    const controlsContainer = $el.find(`.${css}__controls`)[0];

    if (!container || !controlsContainer) {
        console.warn(`Не найдены слайды или управляющие кнопки в слайдере <.${css}>`);
        return;
    }

    tns({
        container,
        controlsContainer,
        items: 1,
        loop : false,
        nav  : false,
    });
});

$('.carousel').each(function () {
    const css               = 'carousel';
    const $el               = $(this);
    const container         = $(`.${css}__main`, $el)[0];
    const controlsContainer = $(`.${css}__controls`, $el)[0];

    if (!container || !controlsContainer) {
        console.warn(`Не найдены слайды или управляющие кнопки в слайдере <.${css}>`);
        return;
    }

    tns({
        container,
        controlsContainer,
        items: 1,
        gutter: 30,
        loop : true,
        nav  : false,

        responsive: {
            768: {
                items: 3
            },
        }
    });
});
